import { create } from 'zustand'

/**
 * Tiny in-app toast queue. Shown top-of-viewport as a stack of glass tiles
 * that auto-dismiss after 5s. Used for realtime "wife logged X" pings + any
 * ephemeral confirmations.
 */

export interface Toast {
  id: string
  title: string
  body: string
  /** 'coral' | 'mint' — background bloom color */
  tone?: 'coral' | 'mint'
  /** ms until auto-dismiss, default 5000 */
  ttl?: number
  /** click target (optional) */
  url?: string
}

interface ToastStore {
  toasts: Toast[]
  push: (t: Omit<Toast, 'id'>) => void
  dismiss: (id: string) => void
  clear: () => void
}

export const useToasts = create<ToastStore>((set, get) => ({
  toasts: [],
  push: (t) => {
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`
    const toast: Toast = { id, ...t }
    set({ toasts: [...get().toasts, toast] })
    const ttl = toast.ttl ?? 5000
    setTimeout(() => get().dismiss(id), ttl)
  },
  dismiss: (id) => set({ toasts: get().toasts.filter((t) => t.id !== id) }),
  clear: () => set({ toasts: [] }),
}))
